import { useSelector } from 'react-redux'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { StockDocumentInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import { format } from 'date-fns'
import { getStockDocumentTypeText } from '../../../../../common/utils/functions/enumToText'

type Props = {
  startEdit: (el: StockDocumentInterface) => void
  el: StockDocumentInterface
  showDetails: (el: StockDocumentInterface) => void
}

export const Item = ({ startEdit, el, showDetails }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  const getTypeColor = (type: number) => {
    switch (type) {
      case 0:
        return '#4CAF50'
      case 1:
        return '#F44336'
      default:
        return '#9E9E9E'
    }
  }

  const totalItems = el.movements?.reduce((sum, m) => sum + (Number(m.count) || 0), 0) || 0

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        {/* 👇 Теперь слева тип + количество */}
        <div className={classes.header} style={{ color: getTypeColor(el.type) }}>
          {getStockDocumentTypeText(el.type)}
          <span style={{ fontSize: 14, marginLeft: 5 }}>
            {el.movements?.length || 0} / {totalItems} шт
          </span>
        </div>

        {el.createdAt && (
          <div className={classes.el}>
            <div className={classes.label}>Создано</div>
            <div className={classes.date}>{format(new Date(el.createdAt), 'dd.MM.yyy HH:mm')}</div>
            {el.updatedAt && el.updatedAt !== el.createdAt && (
              <>
                <div className={classes.label}>Отредактировано</div>
                <div className={classes.date}>
                  {format(new Date(el.updatedAt), 'dd.MM.yyy HH:mm')}
                </div>
              </>
            )}
          </div>
        )}

        <div className={classes.el}>
          <div className={classes.label}>Номер документа</div>
          <div className={classes.date}>{el.number}</div>
        </div>

        <div className={classes.el}>
          <div className={classes.label}>Торговая точка</div>
          <div className={classes.date}>
            <div className={classes.value}>{el.store?.name || el.storeId}</div>
          </div>
        </div>
      </div>

      <div className={classes.buttons}>
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
        <IconButton display onClick={() => startEdit(el)} icon={edit} alt="Изменить" small />
      </div>
    </div>
  )
}
